import { render, staticRenderFns } from "./DeleteView.vue?vue&type=template&id=75e1bc1a"
import script from "./DeleteView.ts?vue&type=script&lang=ts&external"
export * from "./DeleteView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports